import { GqlAgendaItemKind, type GqlAiCreateInput } from '../../graphql/base-types.graphql';

export function optionalBoardMeetingAgendaItems(meetingId: string): Omit<GqlAiCreateInput, 'order'>[] {
  const ais: Omit<GqlAiCreateInput, 'order'>[] = [
    {
      subjectPrimaryLang: 'VD-rapport',
      subjectSecondaryLang: "CEO's report",
      mandatory: false,
      kind: GqlAgendaItemKind.Standard,
      meetingId,
    },
    {
      subjectPrimaryLang: 'Ekonomisk rapport',
      subjectSecondaryLang: 'Financial report',
      mandatory: false,
      kind: GqlAgendaItemKind.Standard,
      meetingId,
    },
    {
      subjectPrimaryLang: 'Budget',
      subjectSecondaryLang: 'Budget',
      mandatory: false,
      kind: GqlAgendaItemKind.Standard,
      meetingId,
    },
    {
      subjectPrimaryLang: 'Godkännande av protokoll för föregående möte',
      subjectSecondaryLang: 'Approval of meeting minutes for previous meeting',
      mandatory: false,
      kind: GqlAgendaItemKind.PriorMeetingApproval,
      meetingId,
    },
    {
      subjectPrimaryLang: 'Nästa möte',
      subjectSecondaryLang: 'Next meeting',
      mandatory: false,
      kind: GqlAgendaItemKind.NextMeeting,
      meetingId,
    },
  ];
  return ais;
}
